import { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const useAuthToken = () => {
    const [token, setToken] = useState(localStorage.getItem('jwtToken'));

    const saveToken = (newToken) => {
        localStorage.setItem('jwtToken', newToken);
        setToken(newToken);
    };

    const removeToken = () => {
        localStorage.removeItem('jwtToken');
        setToken(null);
    };

    const isTokenValid = () => {
        if (!token) return false;
        try {
            const decoded = jwtDecode(token);
            return decoded.exp * 1000 > Date.now();
        } catch {
            return false;
        }
    };

    return {
        token,
        saveToken,
        removeToken,
        isTokenValid
    };
};

export default useAuthToken;